import { Component, OnInit } from '@angular/core';
import { BreadcrumbModule, BreadcrumbService } from 'xng-breadcrumb';
import {
  apiDocumentationDocBreadcrumbs,
  BreadcrumbNames,
} from '../../utility/constants';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule],
  providers: [BreadcrumbService],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent implements OnInit {
  constructor(private readonly breadcrumbService: BreadcrumbService) {}
  ngOnInit(): void {
    this.setBreadcrumbNames();
  }

  private setBreadcrumbNames() {
    this.breadcrumbService.set('@home', BreadcrumbNames.home);
    this.breadcrumbService.set('@contactsales', BreadcrumbNames.contactsales);
    this.breadcrumbService.set('@shipment-tracking', BreadcrumbNames.shipmentTracking);
    this.breadcrumbService.set('@shipment-info', BreadcrumbNames.shipmentInfo);
    this.breadcrumbService.set('@track-manifest', BreadcrumbNames.manifestTracking);
    this.breadcrumbService.set('@manifest-upload', BreadcrumbNames.manifestUpload);
    this.breadcrumbService.set('@air-waybill', BreadcrumbNames.genAirWaybill);
    this.breadcrumbService.set('@air-waybill-gen-form-tab', BreadcrumbNames.airway);
    this.breadcrumbService.set('@address-book-tab', BreadcrumbNames.addressBook);
    this.breadcrumbService.set('@history-tab', BreadcrumbNames.historyTab);
    this.breadcrumbService.set('@aams-documents', BreadcrumbNames.aams);
    this.breadcrumbService.set(
      '@api-documentation',
      BreadcrumbNames.apiDocumentation,
    );
    for (const [slug, label] of Object.entries(apiDocumentationDocBreadcrumbs)) {
      this.breadcrumbService.set(`@${slug}`, label);
    }
  }
}
